<template>
  <div class="progress-pic-uploader">
    <el-row :gutter="30" class="progress-pic">
      <el-col :span="24">
        <div v-if="showAfter()" class="checkin-pic-box">
          <div class="checkin-pic-container">
            <div class="checkin-pic-title">After Picture</div>
            <div class="pic-box" :style="{ backgroundImage: 'url(' + frontAfterPicture + ')' }">
              <el-button type="default" size="small" @click="onUploadFrontClicked"><i class="fa fa-camera"> </i> Front</el-button>
            </div>
            <div class="pic-box" :style="{ backgroundImage: 'url(' + backAfterPicture + ')' }">
              <el-button type="default" size="small" @click="onUploadBackClicked"><i class="fa fa-camera"> </i> Back</el-button>
            </div>
            <div class="pic-box" :style="{ backgroundImage: 'url(' + sideAfterPicture + ')' }">
              <el-button type="default" size="small" @click="onUploadSideClicked"><i class="fa fa-camera"> </i> Side</el-button>
            </div>
            <div class="pic-box" :class="{uploaded: frontNewsAfterPicture}" :style="{ backgroundImage: 'url(' + frontNewsAfterPicture + ')' }">
              <el-button type="default" size="small" @click="onUploadFrontNewsClicked"><i class="fa fa-camera"></i> Front w/Newspaper</el-button>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="30" class="progress-pic">
      <el-col :span="24">
        <div class="checkin-story-box">
          <div class="checkin-story-container">
            <div class="checkin-pic-title">
              Tell us your story! Why are you participating in the WZA Transformation Challenge?
            </div>
            <el-form style="min-height:120px;" :model="form">
              <el-form-item label>
                <el-input
                  rows="5"
                  placeholder="Will be considered along with photo submissions to pick challenge winner."
                  type="textarea"
                  v-model="form.afterStory" />
              </el-form-item>
              <el-button :loading="savingData" style="float:right; height:40px; display:inline-block;"  @click="submitStory" type="primary">Save</el-button>
            </el-form>
          </div>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="30" class="progress-pic">
      <el-col :span="24">
        <div class="checkin-story-box">
          <div class="checkin-story-container">
            <div class="checkin-pic-title">
              Tell us your story! We want to know all the ups and downs of your transformation journey the past 8-weeks.
            </div>
            <el-form style="min-height:120px;" :model="form">
              <el-form-item label>
                <el-input
                  rows="5"
                  placeholder="Will be considered along with photo submissions to pick challenge winner."
                  type="textarea"
                  v-model="form.afterStory2" />
              </el-form-item>
              <el-button :loading="savingData" style="float:right; height:40px; display:inline-block;"  @click="submitStory2" type="primary">Save</el-button>
            </el-form>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import moment from 'moment';
export default {
  name: "progress-pic",
  mounted() {
    var user = Parse.User.current();
    if (!user) {
      this.$router.push("/login");
      return;
    }
    user.fetch().then(fetchedUser => {
      this.form.afterStory = fetchedUser.get("afterStory");
      this.form.afterStory2 = fetchedUser.get("afterStory2");
      this.frontAfterPicture = fetchedUser.get("frontAfterPicture");
      this.sideAfterPicture = fetchedUser.get("sideAfterPicture");
      this.backAfterPicture = fetchedUser.get("backAfterPicture");
      this.frontNewsAfterPicture = fetchedUser.get("frontNewsAfterPicture");
    }).catch(err => {
      console.log(err);
      this.$message({
        type: 'error',
        message: 'There was an error loading your data. Please contact support.'
      });
    });
  },
  data() {
    return {
      frontAfterPicture: null,
      frontNewsAfterPicture: null,
      backAfterPicture: null,
      sideAfterPicture: null,
      form: {
        afterStory: null,
        afterStory2: null,
      },
      imageSources: [
        "local_file_system",
        "imagesearch",
        "facebook",
        "instagram",
        "dropbox"
      ],
      savingData: false
    };
  },
  methods: {
    submitStory() {
      var user = Parse.User.current();
      if (user) {
        this.savingData = true;
        user.set("afterStory", this.form.afterStory);
        user.save().then(savedUser => {
          this.savingData = false;
          this.$message({
            type: "success",
            message: "Your story has been saved!"
          });
        });
      }
    },
    submitStory2() {
      var user = Parse.User.current();
      if (user) {
        this.savingData = true;
        user.set("afterStory2", this.form.afterStory2);
        user.save().then(savedUser => {
          this.savingData = false;
          this.$message({
            type: "success",
            message: "Your story has been saved!"
          });
        });
      }
    },
    showAfter() {
      return moment().diff(moment('2019-06-22','YYYY-MM-DD'), 'minutes') >= 0;
    },
    saveBeforePicture(imageField, imageUrl) {
      var user = Parse.User.current();
      user.set(imageField, imageUrl);
      user.save().then(() => {
        this[imageField] = imageUrl;
        this.$message({
          type: "success",
          message: "Your image has been saved!"
        });
      }).catch(err => {
        console.log(err);
        this.$message({
          type: "error",
          message: "There was an error saving your image."
        });
      });
    },
    onUploadFrontClicked: function openPicker() {
      var _this = this;
      window.fsClient
			.pick({
				fromSources: _this.imageSources
			})
			.then(function(response) {
				// declare this function to handle response
				if (response.filesUploaded.length) {
					_this.saveBeforePicture(
						"frontAfterPicture",
						response.filesUploaded[0].url
					);
				}
			});
    },
    onUploadBackClicked: function openPicker() {
      var _this = this;
      window.fsClient
        .pick({
          fromSources: _this.imageSources
        })
        .then(function(response) {
          // declare this function to handle response
          if (response.filesUploaded.length) {
            _this.saveBeforePicture(
              "backAfterPicture",
              response.filesUploaded[0].url
            );
          }
        });
    },
    onUploadSideClicked: function openPicker() {
      var _this = this;
      window.fsClient
			.pick({
				fromSources: _this.imageSources
			})
			.then(function(response) {
				// declare this function to handle response
				if (response.filesUploaded.length) {
					_this.saveBeforePicture(
						"sideAfterPicture",
						response.filesUploaded[0].url
					);
				}
			});
    },
    onUploadFrontNewsClicked: function openPicker() {
      var _this = this;
      window.fsClient
        .pick({
          fromSources: _this.imageSources
        })
        .then(function(response) {
          // declare this function to handle response
          if (response.filesUploaded.length) {
            _this.saveBeforePicture(
              "frontNewsAfterPicture",
              response.filesUploaded[0].url
            );
          }
        });
    }
  }
};
</script>

<style>
.checkin-pic-box {
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.checkin-pic-container {
  height: 280px;
  background-size: cover;
}
.checkin-story-box {
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  min-height: 180px;
  padding-bottom: 40px;
}
.checkin-story-container form {
  padding: 20px;
}
.checkin-pic-container button {
  margin-top: 90px;
}
.checkin-pic-title {
  width: 100%;
  height: 50px;
  background-color: #f1f1f1;
  line-height: 50px;
  color: #999;
}
.checkin-pic-container .pic-box {
  width: 25%;
  height: 180px;
  float: left;
  box-sizing: border-box;
  border-right: 1px solid #eee;
  background-size: cover;
  background-position: top;
}
.checkin-pic-container .pic-box:last-of-type {
  border: 0;
}
</style>